import { blueGrey } from "@mui/material/colors";
import {
  CardsThreeIcon,
  GKButton,
  Grid2,
  Typography,
  UserRectangleIcon,
} from "components";
import { RightArrowIcon } from "Pages/Website/Icons";
import { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useDocumentTitle from "utils/useDocumentTitle";
import OnboardingAuth from "./OnboardingAuth";

const cardDetails = [
  {
    title: "Personal Info",
    description: "Basic information to set up your profile.",
    icon: UserRectangleIcon,
  },
  {
    title: "Review Your Details",
    description: "Review and confirm all the information you’ve provided.",
    icon: CardsThreeIcon,
  },
];

const InvestorMFOnboarding = () => {
  useDocumentTitle("Investor / Get Started");

  const location = useLocation();

  const [searchParams] = useSearchParams();

  const [showAuth, setShowAuth] = useState(false);

  const logo = location.search.split("logo=")[1];

  const clientName = searchParams.get("client_name");

  // After the user starts, gate the onboarding behind OTP verification.
  if (showAuth) {
    return <OnboardingAuth />;
  }

  return (
    <Grid2 container bgcolor={"#fff"} height={"100vh"} alignItems={"center"}>
      <Grid2
        container
        spacing={{ md: 6, xs: 2 }}
        p={{ xs: 2, md: 5 }}
        size={{ xs: 12, md: 6 }}
      >
        <Grid2
          size={12}
          display="flex"
          justifyContent={{ xs: "center", md: "flex-start" }}
        >
          <img
            src={logo || "/Logos/iconFullLogo.png"}
            alt=""
            height={`-webkit-fill-available`}
            width={"auto"}
            style={{ maxHeight: "32px" }}
            onError={({ currentTarget }) => {
              currentTarget.src = "https://gridkey.in/Logos/iconFullLogo.png";
            }}
          />
        </Grid2>
        <Grid2
          size={12}
          display={"flex"}
          flexDirection={"column"}
          gap={1}
          alignItems={{ xs: "center", md: "flex-start" }}
        >
          <Typography
            fontWeight={700}
            bgcolor={"var(--primary-100)"}
            color={"var(--primary-900)"}
            width={"max-content"}
            px={2}
            py={1}
            borderRadius={2}
            fontSize={{ md: 24 }}
          >
            Welcome, {clientName || "Investor"}!
          </Typography>
          <Typography
            fontWeight={600}
            sx={{ fontSize: "clamp(1.375rem, 0.5938rem + 2.5vw, 2rem)" }}
            textAlign={{ xs: "center", md: "left" }}
          >
            Your Investment journey begins here
          </Typography>
          <Typography
            fontWeight={500}
            color={blueGrey[400]}
            sx={{ fontSize: "clamp(1rem, 0.6875rem + 1vw, 1.25rem)" }}
            textAlign={{ xs: "center", md: "left" }}
          >
            Click <span style={{ color: blueGrey[600] }}>Get started</span> and
            complete your onboarding in no time!
          </Typography>
        </Grid2>
        <Grid2
          size={12}
          display="flex"
          justifyContent={{ xs: "center", md: "flex-start" }}
        >
          <GKButton
            variant="contained"
            size="large"
            endIcon={<RightArrowIcon />}
            sx={{
              width: { xs: "100%", md: "fit-content" },
              maxWidth: { md: "fit-content" },
            }}
            onClick={() => setShowAuth(true)}
          >
            Get Started
          </GKButton>
        </Grid2>
      </Grid2>
      <Grid2
        container
        spacing={2}
        p={{ xs: 1, md: 5 }}
        size={{ xs: 12, md: 6 }}
        bgcolor={"var(--grey-bg-100)"}
        height={{ xs: "auto", md: "100%" }}
        alignContent={{ xs: "flex-start", md: "center" }}
      >
        <Grid2 size={12} pt={3} pb={1}>
          <Typography
            fontWeight={600}
            fontSize={10}
            color="var(--neutral-500)"
            textTransform={"uppercase"}
          >
            Just a few quick steps:
          </Typography>
        </Grid2>
        <Grid2 container size={12} spacing={0}>
          {cardDetails.map((dataItem, index) => (
            <Grid2
              key={index}
              size={{ xs: 12 }}
              container
              spacing={2}
              alignItems={"center"}
              borderBottom={"solid 1px var(--grey-100)"}
              py={2}
            >
              <Grid2 size={"auto"}>
                <Typography
                  height={28}
                  width={28}
                  bgcolor={"var(--grey-50)"}
                  borderRadius={10}
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"center"}
                  fontWeight={600}
                  fontSize={10}
                >
                  {index + 1}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: "auto" }} container spacing={0}>
                <Grid2 size={12}>
                  <Typography
                    fontWeight={600}
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                    sx={{
                      fontSize: "clamp(0.875rem, 0.7188rem + 0.5vw, 1rem)",
                    }}
                  >
                    {dataItem?.title}
                  </Typography>
                </Grid2>
                <Grid2 size={12}>
                  <Typography fontSize={16} fontWeight={400} color="#697586">
                    {dataItem?.description}
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default InvestorMFOnboarding;
